import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Select,
  MenuItem,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Grid,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Autocomplete,
  Rating,
  Divider,
  Toolbar,
  Tooltip,
  Badge,
  Popover,
  TablePagination,
  FormControlLabel,
} from "@mui/material";
import {
  Star,
  CardGiftcard,
  Warning,
  Refresh,
  CheckCircle,
  Copyright,
  Send,
  Info,
  Description,
  Edit,
  Chat,
  KeyboardArrowDown,
  Close,
  Business,
  ContentCopyOutlined,
  CancelOutlined,
  NoteAddOutlined,
  Summarize,
  SummarizeOutlined,
  NoteAdd,
} from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  ApiEditorClientEntities,
  ApiGetClientEntityByClientGroupId,
  ApiGetShopperPopUpDetails,
  ApiGetVenueList,
  ApiMasterRating,
  ApiQuizreTake,
  ApiReportTempToken,
} from "../../../apiService/Core/Apicall.tsx";
import emoji0 from "../../../assets/images/emoji0.svg";
import emoji1 from "../../../assets/images/emoji1.svg";
import emoji2 from "../../../assets/images/emoji2.svg";
import emoji3 from "../../../assets/images/emoji3.svg";
import emoji4 from "../../../assets/images/emoji4.svg";
import emoji5 from "../../../assets/images/emoji5.svg";
import PatchedReactQuill from "../ManageVenue/PatchedReactQuill.tsx";
import Dcrage from "../OrphanAllocation/Dcrage.tsx";
import { toast } from "react-toastify";
import { CustomDownloadPdf } from "../../../apiService/Core/CustomDownloadPdf.tsx";
import { useSelector } from "react-redux";
import { RootState } from "../../../global/config/store.ts";
import {
  ApiAppproveAndSendEmailtoAldi,
  ApiDeleteReport,
  ApiPostShopperFeedback,
  ApiReportList,
  ApiShopperFeedback,
  ApiUpdateReportStatus,
} from "../../../apiService/Core/CustomApiManageReports.tsx";
import { number } from "yup";
import { useDispatch } from "react-redux";
import { setSelectedClientGroup } from "../../../global/config/Reducer/clientSlice.ts";
import { setDate } from "../../../global/config/Reducer/dateSlice.ts";
import { setSelectedRegionData } from "../../../global/config/Reducer/regionSlice.ts";
import { setSelectedValueData } from "../../../global/config/Reducer/statusSlice.ts";
import { setPageData, setRowsPerPageData } from "../../../global/config/Reducer/paginationSlice.ts";
import { setclientEntityIdData } from "../../../global/config/Reducer/entitySlice.ts";
import Editor from "../ManageVenue/Editor.tsx";

interface Business {
  label: string;
  value: string;
}

// Custom styled button with olive green background
const OliveButton = ({
  children,
  ...props
}: React.ComponentProps<typeof Button>) => (
  <Button
    {...props}
    sx={{
      backgroundColor: "#7a7d52",
      color: "white",
      "&:hover": {
        backgroundColor: "#5e6040",
      },
      textTransform: "none",
      ...props.sx,
    }}
    variant="contained"
  >
    {children}
  </Button>
);

// Action button component for the grid
const ActionButton = ({
  icon,
  label,
  onClick,
}: {
  icon: React.ReactNode;
  label: string;
  onClick?: () => void;
}) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      p: 1,
      border: "1px solid #ccc",
      height: "100%",
      cursor: onClick ? "pointer" : "default",
    }}
    onClick={onClick}
  >
    <Box sx={{ mr: 1 }}>{icon}</Box>
    <Typography variant="body2">{label}</Typography>
  </Box>
);

const emojiMap: { [key: number]: string } = {
  1: emoji1,
  2: emoji2,
  3: emoji3,
  4: emoji4,
  5: emoji5,
};

// Emoji component based on rating
const RatingEmoji = ({ rating }: { rating: number }) => {
  const emojiSrc = emojiMap[rating] || emoji0; // Default to lowest rating emoji

  return (
    <img src={emojiSrc} alt={`Rating: ${rating}`} width={60} height={60} />
  );
};

export default function ManageReports() {
  const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
  const selectedDateRedux = useSelector((state: RootState) => state.date.selectedDate)
  const selectedRegionredux = useSelector((state: RootState) => state.region.selectedRegion)
  const selectedStatusredux = useSelector((state: RootState) => state.status.selectedValue)
  const paginationPage = useSelector((state: RootState) => state.pagination.page)
  const paginationRowsPerPage = useSelector((state: RootState) => state.pagination.rowsPerPage)
  const entityRedux = useSelector((state: RootState) => state.entity.clientEntityId)
  const dispatch = useDispatch()
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date(selectedDateRedux));
  const [shopperFeedback, setShopperFeedback] = useState<any>([]);
  const [displayStatus, setDisplayStatus] = useState(selectedStatusredux);
  const [selectedRow, setSelectedRow] = useState<any>([]);
  const [bonusDialogOpen, setBonusDialogOpen] = useState(false);
  const [penaltyDialogOpen, setPenaltyDialogOpen] = useState(false);
  const [bonusAmount, setBonusAmount] = useState();
  const [bonusReason, setBonusReason] = useState();
  const [businesses, setBusinesses] = useState<Business[]>([]);
  const [penaltyAmount, setPenaltyAmount] = useState(0.0);
  const [penaltyReason, setPenaltyReason] = useState();
  const [editorSummeryDialogOpen, setEditorSummeryDialogOpen] = useState(false);
  const [editorSummery, setEditorSummery] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [masterRating, setmasterRating] = useState<any>([]);
  const [reportlist, setreportlist] = useState<any>([]);
  const [activepopup, setactivepopup] = useState<number>();
  const [datalength, setdatalength] = useState<any>(null);

  const [reportHeaderId, setreportHeaderId] = useState<number>();
  // const Clientlist = useSelector((state: RootState) => state.client.clientList);
  // const [selectedClient, setSelectedClient] = useState(Clientlist[2] || null);
  // const [ClientId, setClientId] = useState(Clientlist[2]?.clientGroupName);
  const Clientlist = useSelector((state: RootState) => state.client.clientList);
  const [selectedClient, setSelectedClient] = useState<any>(selectedClientName);
  const [ClientId, setClientId] = useState(null);
  const [clientEntityId, setclientEntityId] = useState<any>(entityRedux);
  const [regions, setRegions] = useState<any[]>([])
  const [selectedRegion, setSelectedRegion] = useState<any>(selectedRegionredux);
  const [dialogbonusClient, setDialogBonusClient] = useState("");
  const [penaltyClient, setPenaltyClient] = useState("");
  const [summaryClient, setSummaryClient] = useState("");
  const [ratingClient, setRatingClient] = useState("");
  const navigate = useNavigate();
  const userRole: any = localStorage.getItem("userRole");
  const userId: any = localStorage.getItem("userId");
  const [OpenHoldReason, setOpenHoldReason] = useState<boolean>(false)
  const [reasonforhold, setreasonforhold] = useState<any>()
  const [OpenEditDescription, setOpenEditDescription] = useState<boolean>(false)
  const [selectedVenue, setSelectedVenue] = useState<any>([]);
  const [isResetQuiz, setisResetQuiz] = useState<boolean>(false)
  const [briefVenue, setBriefVenue] = useState<any[]>([]);
  const [editedvenueId, seteditedvenueId] = useState<string | number>("");
  const [editedclientEntityId, seteditedclientEntityId] = useState<number | string>("");
  const [isSpecialClient, setisSpecialCLient] = useState(selectedClientName?.clientGroupName === "ALDI")




  useEffect(() => {
    setisSpecialCLient(selectedClientName?.clientGroupName === "ALDI")
  }, [selectedClientName])


  useEffect(() => {
    if (Clientlist.length > 2) {
      // setSelectedClient(Clientlist[2]);
      setClientId(Clientlist[2]?.clientGroupName);
      // handleGetReportList(1);
    }
  }, [Clientlist]);
  useEffect(() => {
    if (selectedRegionredux) {
      setSelectedRegion(selectedRegionredux)
    }
  }, [selectedRegionredux])
  const [loanData, setLoanData] = useState();

  // Shopper Rating Dialog States
  const [ratingDialogOpen, setRatingDialogOpen] = useState(false);
  const [ratings, setRatings] = useState<any>();
  const [ratingComment, setRatingComment] = useState("Thanks for completing");
  const [page, setPage] = useState(paginationPage);
  const [rowsPerPage, setRowsPerPage] = useState(paginationRowsPerPage);
  const [headerId, setHeaderId] = useState<any>(null);
  const [group, setGroup] = useState<any>(null)

  useEffect(() => {
    if (selectedClient && ClientId) {
      handleGetClientList();
    }
    // handleGetReportList(displayStatus);
  }, [selectedClient, ClientId]);

  // const handleGetClientList = async () => {
  //   const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`;
  //   const data2 = `?editorId=${userId}&clientGroupName=${selectedClientName?.clientGroupName}`;

  //   if (!ClientId) return;
  //   try {
  //     const res: any = userRole == 3 ? await ApiEditorClientEntities(data2) : await ApiGetClientEntityByClientGroupId(data);

  //     const response = (res?.data || [])
  //       .filter((item) => item && item.entityName && item.clientEntityId) // Remove null/undefined or incomplete objects
  //       .map((item) => ({
  //         label: item.entityName,
  //         value: item.clientEntityId,
  //       }));

  //     console.log("Filtered data:", response);
  //     setclientEntityId(response[0])
  //     setBusinesses(response);
  //   } catch (error) {
  //     console.error("Error during API call:", error);
  //   }
  // };

  const handleGetClientList = async () => {
    const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`;
    const data2 = `?editorId=${userId}${selectedClient ? `&clientGroupName=${selectedClientName?.clientGroupName}` : ''}`;

    // if (!ClientId) return;
    setBusinesses([])
    // setclientEntityId(null);
    dispatch(setclientEntityIdData(null))
    try {
      const res: any = userRole == 3
        ? await ApiEditorClientEntities(data2)
        : await ApiGetClientEntityByClientGroupId(data);

      const fullBusinessData = res?.data || [];

      const response = fullBusinessData
        .filter((item) => item && item.entityName && item.clientEntityId)
        .map((item) => ({
          label: item.entityName,
          value: item.clientEntityId,
          regions: item.regions || []
        }));

      setBusinesses(response);

      if (response.length > 0) {
        // setclientEntityId(response[0]);
        const selectedEntity = clientEntityId?.value ? clientEntityId : response[0];
        dispatch(setclientEntityIdData(selectedEntity));

        if (isSpecialClient && response[0].regions && response[0].regions.length > 0) {
          const regionOptions = response[0].regions.map((region: any) => ({
            label: region.regionName,
            value: region.regionId
          }));
          setRegions(regionOptions);
          // setSelectedRegion(regionOptions[0]);
          const regionToSet = selectedRegionredux || regionOptions[0];
          setSelectedRegion(regionToSet);
          dispatch(setSelectedRegionData(regionToSet));
        }
      }
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const handleBusinessChange = (event: any, newValue: any) => {
    // setclientEntityId(newValue);
    dispatch(setclientEntityIdData(newValue))
    if (isSpecialClient && newValue) {
      const regionOptions = newValue.regions.map((region: any) => ({
        label: region.regionName,
        value: region.regionId
      }));
      setRegions(regionOptions);
      if (regionOptions.length > 0) {
        setSelectedRegion(regionOptions[0]);
        dispatch(setSelectedRegionData(regionOptions[0]));
      } else {
        setSelectedRegion(null);
        dispatch(setSelectedRegionData(null));
      }
    } else {
      setRegions([]);
      setSelectedRegion(null);
      dispatch(setSelectedRegionData(null));
    }
  };

  useEffect(() => {
    setPage(paginationPage);
  }, [selectedDate, selectedClientName, displayStatus, selectedRegion, clientEntityId])


  const handleHover = async (event, index, item?: any) => {
    setAnchorEl(event.currentTarget);
    try {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1; // Months are zero-based, so add 1
      const currentYear = currentDate.getFullYear();

      const data = `?userId=${item?.userId}&currentMonth=${currentMonth}&currentYear=${currentYear}`;

      // Call API to get shopper details
      const response = await ApiGetShopperPopUpDetails(data);

      if (!response.status) {
        toast.error("Failed to load shopper details");
        return;
      }

      // Set shopper details from API response
      if (response.data) {
        setLoanData(response.data);
      }
    } catch (error) {
      //toast.error("Error loading shopper details");
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  // ------------------------------------------------------Shopper Bonus DialogBox  Handlers ---------------------------------

  const handleOpenBonusDialog = (reportHeaderId: any, clientGroup: any) => {
    setBonusDialogOpen(true);
    setactivepopup(reportHeaderId);
    setDialogBonusClient(clientGroup)
    getshopperfeedback(reportHeaderId, clientGroup);
  };

  const handleCloseBonusDialog = () => {
    setBonusDialogOpen(false);
  };

  // ------------------------------------------------------Shopper Penulty DialogBox  Handlers ---------------------------------

  const handleOpenPenaltyDialog = (reportHeaderId: any, clientGroup: any) => {
    setPenaltyDialogOpen(true);
    setactivepopup(reportHeaderId);
    setPenaltyClient(clientGroup)
    getshopperfeedback(reportHeaderId, clientGroup);
  };

  const handleClosePenaltyDialog = () => {
    setPenaltyDialogOpen(false);
  };

  // ------------------------------------------------------Shopper Summary DialogBox  Handlers ---------------------------------

  const handleOpeneditorSummeryDialog = (reportHeaderId: any, clientGroup: any) => {
    setEditorSummeryDialogOpen(true);
    setSummaryClient(clientGroup)
    setactivepopup(reportHeaderId);

    getshopperfeedback(reportHeaderId, clientGroup);
  };

  const handleCloseEditorSummeryDialog = () => {
    setEditorSummeryDialogOpen(false);
  };
  // ------------------------------------------------------Shopper Bonus Handlers ---------------------------------

  const handleSaveBonus = async () => {
    const data = {
      reportHeaderId: activepopup,
      createdBy: Number(localStorage.getItem("createdBy")),
      bonus: {
        bonusAmount: bonusAmount,
        bonusReason: bonusReason,
      },
    };
    try {
      const response = await ApiPostShopperFeedback(data, dialogbonusClient);
      toast.success(response.message);
      handleGetReportList(displayStatus);
      setDialogBonusClient("");
    } catch (error) {
      toast.error(error);
    }
    setBonusDialogOpen(false);
    // Reset form fields
    //setBonusAmount("");
    //setBonusReason("");
  };
  // ------------------------------------------------------ShopperPenulty Handlers ---------------------------------

  const handleSavePenalty = async () => {
    const data = {
      reportHeaderId: activepopup,
      createdBy: Number(localStorage.getItem("createdBy")),
      penalty: {
        penaltyAmount: penaltyAmount,
        penaltyReason: penaltyReason,
      },
    };
    try {
      const response = await ApiPostShopperFeedback(data, penaltyClient);
      toast.success(response.message);
      handleGetReportList(displayStatus);
      setPenaltyClient("");
    } catch (error) {
      toast.error(error);
    }
    setPenaltyDialogOpen(false);

    // Reset form fields
  };
  // ------------------------------------------------------Shopper Summary Handlers ---------------------------------

  const handleSaveEditorSummery = async () => {
    const data = {
      reportHeaderId: activepopup,
      editorSummary: editorSummery,
      createdBy: Number(localStorage.getItem("createdBy")),
    };
    try {
      const response = await ApiPostShopperFeedback(data, summaryClient);
      toast.success(response.message);
      handleGetReportList(displayStatus);
      setSummaryClient("")
    } catch (error) {
      toast.error(error);
    }
    setEditorSummeryDialogOpen(false);
  };

  // ------------------------------------------------------Shopper Rating Dialog Handlers ---------------------------------

  const handleOpenRatingDialog = async (reportHeaderId: any, clientGroup: any) => {
    await getshopperfeedback(reportHeaderId, clientGroup);
    setRatingDialogOpen(true);
    setRatingClient(clientGroup)
    setactivepopup(reportHeaderId);
  };
  const handleCloseRatingDialog = () => {
    setRatingDialogOpen(false);
  };

  // -------------------------------------------------------------------Save Rating ---------------------------------
  const handleSaveRating = async () => {
    const ratingData = {
      reportHeaderId: activepopup,
      createdBy: Number(localStorage.getItem("createdBy")),
      shopperRating: ratings,
      commentForShopper: ratingComment,
    };
    try {
      const response = await ApiPostShopperFeedback(ratingData, ratingClient);
      toast.success(response.message);
      handleGetReportList(displayStatus);
      setRatingClient("");
    } catch (error) {
      toast.error(error);
    }

    setRatingDialogOpen(false);
  };

  // -------------------------------------------------- Handle Rating Change -----------------------------------------
  const handleRatingChange = (category: number, value: number) => {
    setRatings((prevRatings) => {
      // Find the existing rating by ID
      const existingIndex = prevRatings.findIndex(
        (item) => item.overRatingId === category
      );

      if (existingIndex !== -1) {
        // Update the existing rating
        return prevRatings.map((item) =>
          item.overRatingId === category
            ? { ...item, overAllRatingScore: value }
            : item
        );
      } else {
        // Add a new rating entry
        return [
          ...prevRatings,
          { overRatingId: category, overAllRatingScore: value },
        ];
      }
    });

  };
  useEffect(() => {
    const masterrating = async () => {
      try {
        const response = await ApiMasterRating();
        setmasterRating(response.data);
      } catch (error) {
        toast.error(error);
      }
    };
    masterrating();
  }, []);

  // -------------------------------------------------Get ReportList ----------------------------------------------
  // useEffect(() => {
  //   if (!selectedDate) return;

  //   handleGetReportList(displayStatus);
  // }, [selectedDate, clientEntityId, page, rowsPerPage, selectedRegion]);
  const latestRequestId = useRef(0);
  useEffect(() => {
    if (!selectedDate || !ClientId || !clientEntityId) {
      return;
    }
    // For special clients (ALDI), wait for region to be set if regions exist
    if (isSpecialClient && regions.length > 0 && !selectedRegion) {
      handleGetReportList(displayStatus);
      return;
    }

    handleGetReportList(displayStatus);
  }, [selectedDate, clientEntityId, page, rowsPerPage, selectedRegion]);


  const handleGetReportList = async (number?: any) => {
    setreportlist([])
    const requestId = ++latestRequestId.current;
    if (!clientEntityId) {
      setRegions([])
      setSelectedRegion(null)
    }
    if (!selectedDate)
      return;
    if (ClientId && clientEntityId?.value) {
      try {
        const response = await ApiReportList(
          page,
          rowsPerPage,
          selectedDate?.getMonth() + 1,
          selectedDate?.getFullYear(),
          number,
          selectedClientName?.clientGroupName,
          clientEntityId,
          selectedRegion?.value,
          userId,
        );
        if (requestId !== latestRequestId.current) {
          return;
        }
        if (response.status) {
          setdatalength(response.totalDataCount)
          setreportlist(response.data);
        }
      } catch (error) {
        alert(error)
        console.log("Error", error)
        if (requestId !== latestRequestId.current) {
          return;
        }
        console.log(error)
      }
    }

  };

  // ------------------------------------------- Chnage Pagination -----------------------------------------------
  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage);
    dispatch(setPageData(newPage))
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    dispatch(setRowsPerPageData(parseInt(event.target.value, 10)))
    dispatch(setPageData(0));
  };

  // ------------------------------------------Get ShopperFeedback ----------------------------------
  const getshopperfeedback = async (reportHeaderId: any, clientGroup: any) => {
    const response = await ApiShopperFeedback(reportHeaderId, clientGroup);
    // setShopperFeedback(response.data)
    setRatings(
      response.data.ratings.map((rating) => ({
        overAllRatingScore: parseInt(rating.overAllRatingScore),
        overRatingId: rating.overRatingId.overAllRatingId,
      }))
    );
    setEditorSummery(response.data.reportHeader.editorComment);
    setBonusAmount(response.data.reportHeader.bonus);
    setBonusReason(response.data.reportHeader.bonusReason);
    setPenaltyAmount(response.data.reportHeader.penalty);
    setPenaltyReason(response.data.reportHeader.penaltyReason);
    setRatingComment(response.data.reportHeader.commentForShopper);
  };

  const handleDisplayChange = async (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const selectedValue = event.target.value as number;
    setDisplayStatus(selectedValue);
    dispatch(setSelectedValueData(selectedValue))
    if (ClientId && clientEntityId) {
      try {
        // Call your API here
        if (!selectedDate) return;
        const response = await ApiReportList(
          page,
          rowsPerPage,
          selectedDate?.getMonth() + 1,
          selectedDate?.getFullYear(),
          selectedValue,
          selectedClientName?.clientGroupName,
          clientEntityId,
          selectedRegion?.value,
          userId
        );
        setdatalength(response.totalDataCount)
        setreportlist(response.data);
      } catch (error) {
        console.error("Error updating status:", error);
      }

    }

  };

  const handleEditScoreCard = (allocationId: any) => {
    const url = `/createOrEditScoreCard/${allocationId}?clientGroup=${ClientId}`
    window.open(url, '_blank')
    // navigate(`/createOrEditScoreCard/${allocationId}`, {
    //   state: { clientGroup: ClientId },
    // });
    //window.open(`/createOrEditScoreCard/${allocationId}`, "_blank");
  };

  const handleApproved = async (reportHeaderId: any, Status: any, canClientEditReports: any, clientGroup: any) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to Approve this report?"
    );
    if (isConfirmed) {
      try {
        const data = {
          reportHeader: [
            {
              reportHeaderId: reportHeaderId,
              canClientEditReports: canClientEditReports === 1 ? true : false
            }

          ],
          status: Status,
          approvedBy: Number(userId)
        };
        // Call your API here
        const response = await ApiUpdateReportStatus(data, clientGroup);
        toast.success("Status updated successfully");
        handleGetReportList(Number(displayStatus));
      } catch (error) {
        console.error("Error updating status:", error);
      }
    }
  };

  const handleReleased = async (reportHeaderId: any, Status: any, canClientEditReports: any, clientGroup: any) => {
    const isConfirmed = window.confirm(
      reportHeaderId > 0 ? "Are you sure you want to Release this report?" : "Are you sure you want to Release selected reports?"
    );

    if (isConfirmed) {
      const canClient = reportlist.find(item => item?.reportHeaderId === reportHeaderId)?.canClientEditReports;

      const results = selectedRow
        .map(selectedItem => {
          const item = reportlist.find(
            reportItem => reportItem?.reportHeaderId === selectedItem.reportHeaderId &&
              reportItem?.allocationClientGroup === selectedItem.clientGroup
            // reportItem?.canClientEditReports === 0
          );
          return item ? {
            reportHeaderId: item.reportHeaderId,
            canClientEditReports: false
          } : null;
        })
        .filter(Boolean);

      try {
        const data = {
          reportHeader: reportHeaderId > 0 ?
            [{
              reportHeaderId: reportHeaderId,
              canClientEditReports: canClient ? true : false

            }] :
            results,
          status: Status,
          approvedBy: Number(userId)
        };

        if (reportHeaderId === 0) {
          if (selectedRow.length === 0) {
            alert("Please select at least one report to release");
            return;
          }
          if (results.length !== selectedRow.length) {
            alert("Cannot release selected reports.");
            return;
          }
        }

        const response = await ApiUpdateReportStatus(data, clientGroup);
        toast.success("Status updated successfully");
        handleGetReportList(Number(displayStatus));
      } catch (error) {
        console.error("Error updating status:", error);
      } finally {
        setSelectedRow([]);
      }
    }
  };

  const handleDownloadPdf = async (allocationId: any, ClientGroupName: any, isAllowDownloadWithoutComments = false, venuename: any, venueCode: any) => {
    try {
      await CustomDownloadPdf(allocationId, ClientGroupName, isAllowDownloadWithoutComments, venuename, venueCode, (selectedDate && selectedDate?.getMonth() + 1), selectedDate?.getFullYear());
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error(error);
    }
  };

  const handleRollBack = async (Status: any) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to Rollback this report?"
    );
    if (isConfirmed) {
      try {
        const data = {
          reportHeader: [
            {
              reportHeaderId: headerId,
              canClientEditReports: false
            }
          ],
          status: Status,
          reason: reasonforhold
        };

        // Call your API here
        const response = await ApiUpdateReportStatus(data, group);
        toast.success("Status updated successfully");
        handleGetReportList(displayStatus);
        setOpenHoldReason(false);
        setHeaderId(null);
        setreasonforhold(null);
        setGroup(null);
      } catch (error) {
        console.error("Error updating status:", error);
      }
    }
  };

  const handleDelteReport = async () => {
    const isConfirmed = window.confirm(
      "Are you sure you want to Delete this report?"
    );
    if (isConfirmed) {
      try {
        if (selectedRow.length === 0) {
          alert("Please select at least one report to delete");
          return;
        }
        const groupedByClient = selectedRow.reduce((acc, item) => {
          if (!acc[item.clientGroup]) {
            acc[item.clientGroup] = [];
          }
          acc[item.clientGroup].push(item.reportHeaderId);
          return acc;
        }, {});

        // Call delete API for each client group
        const deletePromises = Object.entries(groupedByClient).map(
          async ([clientGroup, reportHeaderIds]) => {
            const data = {
              reportHeaderIds: reportHeaderIds
            };
            return await ApiDeleteReport(data, clientGroup);
          }
        );

        // Wait for all delete operations to complete
        await Promise.all(deletePromises);

        toast.success("Reports deleted successfully");
        handleGetReportList(1);
        setSelectedRow([])
      } catch (error) {
        console.error("Error updating status:", error);
      }
    }
  };
  // const handleAPrroveandSendMailtoAldi = async () => {
  //   const isConfirmed = window.confirm(
  //     "Are you sure you want to Approve this Reports and Send mail to ALDI?"
  //   );
  //   if (isConfirmed) {

  //     const selectedAllocationIds = reportlist
  //       .filter(item => selectedRow.includes(item.reportHeaderId))
  //       .map(item => item.allocationId);

  //     try {
  //       const data = {allocationIds:selectedAllocationIds}
  //       const response = await ApiAppproveAndSendEmailtoAldi(data, ClientId);
  //       toast.success("Status updated successfully");
  //       handleGetReportList(1);
  //       setSelectedRow([])
  //     } catch (error) {
  //       console.error("Error updating status:", error);
  //     }
  //   }
  // };

  const handleAPrroveandSendMailtoAldi = async () => {
    const isConfirmed = window.confirm(
      "Are you sure you want to Approve this Reports and Send mail to ALDI?"
    );

    if (isConfirmed) {
      try {
        if (selectedRow.length === 0) {
          alert("Please select at least one report to approve and send to ALDI");
          return;
        }

        const aldiReports = selectedRow.filter(item => item.clientGroup === "ALDI");

        if (aldiReports.length === 0) {
          alert("No ALDI reports selected. Please select ALDI reports to proceed.");
          return;
        }

        if (aldiReports.length !== selectedRow.length) {
          alert("Mixed client groups selected. Please select only ALDI reports for this operation.");
          return;
        }

        const selectedAllocationIds = reportlist
          .filter(item =>
            aldiReports.some(selected => selected.reportHeaderId === item.reportHeaderId)
          )
          .map(item => item.allocationId);

        const data = { allocationIds: selectedAllocationIds };
        const response = await ApiAppproveAndSendEmailtoAldi(data, "ALDI");

        toast.success("Status updated successfully");
        handleGetReportList(displayStatus);
      } catch (error) {
        console.error("Error updating status:", error);
        toast.error("Error processing ALDI reports");
      } finally {
        setSelectedRow([]);
      }
    }
  };

  useEffect(() => {
    if (businesses.length > 0) {
      // setclientEntityId(businesses[0]);
      // dispatch(setclientEntityIdData(businesses[0]))
    }
  }, [businesses])

  useEffect(() => {
    setclientEntityId(entityRedux)
  }, [entityRedux])


  // const handleSelectRow = (index: number) => {
  //   setSelectedRow((prev) =>
  //     prev.includes(index)
  //       ? prev.filter((i) => i !== index)
  //       : [...prev, index]
  //   );
  // };

  const handleSelectRow = (reportHeaderId: number, clientGroup: string) => {
    setSelectedRow((prev) => {
      const isSelected = prev.some(item =>
        item.reportHeaderId === reportHeaderId && item.clientGroup === clientGroup
      );

      if (isSelected) {
        return prev.filter(item =>
          !(item.reportHeaderId === reportHeaderId && item.clientGroup === clientGroup)
        );
      } else {
        return [...prev, { reportHeaderId, clientGroup }];
      }
    });
  };

  const reportWindows = new Map<string, Window>();

  function openReport(reportId: string | number, token: string): void {
    const name = `report-${reportId}`;
    const url = `${process.env.REACT_APP_SHOPPER_SITE}?x-z-a=${encodeURIComponent(token)}`;

    // Tab opened from this page and still open → focus it
    const existing = reportWindows.get(name);
    if (existing && !existing.closed) {
      existing.focus();
      // toast.info('This report is already open in another tab.');
      return;
    }

    // Get the tab with this name without navigating it (creates a blank tab if none exists)
    const w = window.open('', name);
    if (!w) {
      toast.info('Please allow pop-ups for this site to open reports.');
      return;
    }

    let isNewTab = false;
    try {
      isNewTab = w.location.href === 'about:blank';
    } catch {
      // Cross-origin access denied → report already loaded in that tab
    }

    if (isNewTab) {
      w.location.href = url;
    } else {
      w.focus();
      // toast.info('This report is already open in another tab.');
    }
    reportWindows.set(name, w);
  }

  const OpenEditReport = async (item: any) => {
    try {
      const data = {
        reportHeaderId: item.reportHeaderId,
        allocationId: item.allocationId,
        clientGroupName: item?.allocationClientGroup
      }
      const res = await ApiReportTempToken(data)
      if (res.success) {
        sessionStorage.setItem('fromOriginalSite', 'true');
        // openReport(item.reportHeaderId, res?.data?.token)
        window.open(`${process.env.REACT_APP_SHOPPER_SITE}?x-z-a=${res?.data?.token}`, '_blank');
      }
      else {
        toast.error(res?.message)
      }
    } catch (error: any) {
      toast.error(error?.message)
    }
  }
  useEffect(() => {
    setSelectedClient(selectedClientName)
    selectedClientName !== "ALDI" && setSelectedRegion(null)
  }, [selectedClientName])

  useEffect(() => {
    if (selectedDateRedux) {
      setSelectedDate(new Date(selectedDateRedux))
    }
  }, [selectedDateRedux])



  const quizretake = async () => {
    const data = {
      "clientEntityId": editedclientEntityId,
      "venueId": editedvenueId,
      "venueDescription": normalizeListHtml(ratingComment),
      "retakeRequired": isResetQuiz,
      "commonVenueIds": selectedVenue?.join(",")
    }
    // console.log("ENd Values",)
    try {
      const response = await ApiQuizreTake(data)
      toast.success(response.message)
      seteditedclientEntityId("")
      seteditedvenueId("")
      setSelectedVenue(null)
      setisResetQuiz(false)
    }
    catch (error: any) {
      toast.error(error)
    }
    finally {
      setOpenEditDescription(false)
    }
  }


  useEffect(() => {
    if (editedclientEntityId) {
      const handleGetVenueListForBrief = async () => {
        const data = `?clientEntityId=${clientEntityId?.value}&venueStatus=active&limit=1000`;
        setBriefVenue([])
        try {
          const response: any = await ApiGetVenueList(data);
          setBriefVenue(response.data);
          const venueMessage = response?.data?.find((item: any) => item?.venueId === editedvenueId)?.venueDescription
          setRatingComment(venueMessage)
        } catch (error) {
          console.error("Error during API call:", error);
        }
      };
      handleGetVenueListForBrief()
    }
  }, [editedclientEntityId, editedvenueId])



  const normalizeListHtml = (html: string): string => {
    const parser = new DOMParser()
    console.log("New Data", html)
    const doc = parser.parseFromString(html, "text/html")

    // Convert Quill list structure to semantic UL/OL
    const listItems = doc.querySelectorAll("li")

    listItems.forEach((li) => {
      const listType = li.getAttribute("data-list")
      const parent = li.parentElement

      if (!parent || !listType) return

      // Remove Quill-specific attribute
      li.removeAttribute("data-list")

      if (listType === "bullet") {
        if (parent.tagName.toLowerCase() === "ol") {
          const ul = doc.createElement("ul")

          // Copy existing attributes if any
          Array.from(parent.attributes).forEach((attr) => {
            ul.setAttribute(attr.name, attr.value)
          })

          parent.parentNode?.replaceChild(ul, parent)

          // Move all li elements into UL
          Array.from(parent.children).forEach((child) => {
            ul.appendChild(child)
          })
        }
      }

      if (listType === "ordered") {
        if (parent.tagName.toLowerCase() === "ul") {
          const ol = doc.createElement("ol")

          Array.from(parent.attributes).forEach((attr) => {
            ol.setAttribute(attr.name, attr.value)
          })

          parent.parentNode?.replaceChild(ol, parent)

          Array.from(parent.children).forEach((child) => {
            ol.appendChild(child)
          })
        }
      }
    })

    // Remove any remaining Quill-specific list attributes/classes
    doc.querySelectorAll("li").forEach((li) => {
      li.removeAttribute("data-list")
      li.classList.remove("ql-indent-1", "ql-indent-2", "ql-indent-3")
    })

    return doc.body.innerHTML
  }


  const formatDuration = (start?: string | Date, end?: string | Date): string => {
  if (!start || !end) return '';
  const diffMs = new Date(end).getTime() - new Date(start).getTime();
  if (Number.isNaN(diffMs) || diffMs < 0) return '';

  const totalSeconds = Math.floor(diffMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (totalSeconds < 60) return `${seconds}s`;
  if (hours === 0) return `${minutes}m`;
  if (minutes === 0) return `${hours}h`;
  return `${hours}h ${minutes}m`;
};

  return (
    <Box sx={{ maxWidth: "100%", overflow: "hidden" }} className='p-2'>
      <Box className='bg-light border-10'>
        {/* Header */}
        <Box sx={{ p: 3, textAlign: "center", mb: 2 }}>
          <Typography variant="h4" component="h1" fontWeight="bold">
            Manage Reports
          </Typography>
        </Box>

        {/* Controls */}
        <Box sx={{ display: "flex", justifyContent: "center", mb: 2, px: 2 }}>
          {/* <OliveButton>All Report Status</OliveButton> */}

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              views={["month", "year"]}
              label=""
              value={selectedDate}
              onChange={(newDate) => { setSelectedDate(newDate); dispatch(setDate(newDate)) }}
              format="MM/yyyy"
              sx={{
                width: "400px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: 1,
                },
              }}
            />
          </LocalizationProvider>

          {/* <OliveButton>DOWNLOAD AS XLS</OliveButton> */}
        </Box>

        <Grid
          container
          alignItems={'center'}
          className='px-3 w-100 mb-3'
          gap={2}
        >
          {/* Left: Autocomplete Field */}
          <Grid size={{ xs: 12, md: "grow" }}>
            <Box sx={{ flex: 1 }}>
              <Autocomplete
                id="mm-autocomplete"
                options={Clientlist}
                value={selectedClient}
                getOptionLabel={(option) => option?.clientGroupName}
                isOptionEqualToValue={(option, value) =>
                  option.clientGroupDBName === value.clientGroupDBName
                }
                onChange={(event, newValue: any) => {
                  // setSelectedClient(newValue);
                  dispatch(setSelectedClientGroup(newValue))
                  setClientId(newValue?.clientGroupName || null);
                  dispatch(setclientEntityIdData(null));
                  setclientEntityId(null)
                  // if (!newValue) {
                  //   setClientEntityList(null);
                  // }
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Select Client" />
                )}
              //sx={{ width: "20%" }}
              />
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: "grow" }}>
            <Box className="d-flex align-items-center justify-content-between" sx={{ flex: 1, gap: 1 }}>
              <Autocomplete
                sx={{ width: isSpecialClient ? '50%' : '100%' }}
                options={businesses}
                value={clientEntityId}
                onChange={handleBusinessChange}
                getOptionLabel={(option) => option.label || ''}
                isOptionEqualToValue={(option, value) =>
                  option?.value === value?.value
                }
                renderInput={(params) => (
                  <TextField {...params} label="Select Business" />
                )}
              />
              {isSpecialClient && (
                <Autocomplete
                  sx={{ width: '50%' }}
                  options={regions}
                  value={selectedRegion}
                  onChange={(event, newValue: any) => {
                    setSelectedRegion(newValue);
                    dispatch(setSelectedRegionData(newValue))
                  }}
                  getOptionLabel={(option) => option.label || ''}
                  renderInput={(params) => (
                    <TextField {...params} label="Select Region" />
                  )}
                />
              )}
            </Box>
          </Grid>

          {/* Right: Update Button */}
          <Grid size={{ xs: 12, md: "auto" }}>
            <Box className='d-flex justify-content-end'>
              <OliveButton onClick={() => { window.location.reload() }}>Update</OliveButton>
            </Box>
          </Grid>
        </Grid>

        {/* Display dropdown */}
        <Box
          sx={{
            p: 2,
            border: "1px solid #e0e0e0",
            borderRadius: 1,
            mx: 2,
            mb: 2,
          }}
        >
          <Typography variant="body2" sx={{ mb: 1 }}>
            Display...
          </Typography>
          <FormControl fullWidth>
            <Select
              value={displayStatus}
              onChange={(e: any) => handleDisplayChange(e)}
              displayEmpty
              sx={{ borderRadius: 1 }}
              IconComponent={KeyboardArrowDown}
            >
              <MenuItem value="1">
                Unconfirmed (not yet ready for approval)
              </MenuItem>
              <MenuItem value="2">Confirmed(Ready for your approval)</MenuItem>
              <MenuItem value="3">
                Approved(Already sent to site administrator)
              </MenuItem>
              <MenuItem value="4">
                Released(Site admin has release to sites)
              </MenuItem>
              <MenuItem value="5">
                Approve to Client
              </MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* Release Selected button */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2, px: 2, gap: 1 }}>
          <OliveButton onClick={() => { handleReleased(0, 'rel', '', selectedRow[0].clientGroup) }}>Release Selected</OliveButton>
          {selectedClient?.clientGroupName === "ALDI" && (<OliveButton onClick={() => { handleAPrroveandSendMailtoAldi() }}>Release Selected and Send to ALDI</OliveButton>)}
        </Box>

        {/* Action buttons grid */}
        <Box
          sx={{
            border: "1px solid #ccc",
            borderRadius: 1,
            mx: 2,
            mb: 2,
            overflow: "hidden",
          }}
        >
          <Grid container>
            <Grid size={{ xs: 6, md: 3, lg: 2 }}>
              <ActionButton icon={<Star />} label="Shopper Ratings" />
            </Grid>
            <Grid size={{ xs: 6, md: 3, lg: 2 }}>
              <ActionButton icon={<CardGiftcard />} label="Bonus" />
            </Grid>
            <Grid size={{ xs: 6, md: 3, lg: 2 }}>
              <ActionButton icon={<Warning />} label="Penalty" />
            </Grid>
            <Grid size={{ xs: 6, md: 3, lg: 2 }}>
              <ActionButton icon={<Refresh />} label="RollBack" />
            </Grid>
            <Grid size={{ xs: 6, md: 3, lg: 2 }}>
              <ActionButton icon={<CheckCircle sx={{ color: 'green !important' }} />} label="Approve" />
            </Grid>
            <Grid size={{ xs: 6, md: 3, lg: 2 }}>
              <ActionButton icon={<Copyright />} label="Redcape Report" />
            </Grid>
          </Grid>
          <Grid container>
            <Grid size={{ xs: 6, md: 3, lg: 2 }}>
              <ActionButton icon={<Send sx={{ color: 'red !important' }} />} label="Release" />
            </Grid>
            <Grid size={{ xs: 6, md: 3, lg: 2 }}>
              <ActionButton icon={<Info />} label="Update Shopper" />
            </Grid>
            <Grid size={{ xs: 6, md: 3, lg: 2 }}>
              <ActionButton icon={<Description />} label="PDF DOWNLOAD" />
            </Grid>
            <Grid size={{ xs: 6, md: 3, lg: 2 }}>
              <ActionButton icon={<Edit />} label="Edit Report" />
            </Grid>
            <Grid size={{ xs: 6, md: 3, lg: 2 }}>
              <ActionButton icon={<Chat />} label="Editor Summary" />
            </Grid>
            <Grid size={{ xs: 6, md: 3, lg: 2 }}>
              <ActionButton icon={<NoteAdd />} label="Brief" />
            </Grid>
          </Grid>
        </Box>

        {/* Delete Selected Reports button */}
        <Box sx={{ mb: 2, px: 2 }}>
          <OliveButton onClick={() => { handleDelteReport() }}>Delete Selected Reports</OliveButton>
        </Box>

        {/* Reports Table */}
        <TableContainer
          component={Paper}
          sx={{ mb: 4, border: "1px solid #ccc" }}
        >
          <Box className='w-100' overflow={'auto'}>
            <Table>
              <TableHead sx={{ bgcolor: "#7a7d52" }}>
                <TableRow>
                  <TableCell padding="checkbox" sx={{ color: "white" }}>
                    <Checkbox
                      indeterminate={
                        selectedRow.length > 0 && selectedRow.length < reportlist.length
                      }
                      checked={reportlist.length > 0 && selectedRow.length === reportlist.length}
                      onChange={(e) => {
                        if (e.target.checked) {
                          // Select all rows
                          // setSelectedRow(reportlist.map((item) => item.reportHeaderId,item.allocationClientGroup));
                          setSelectedRow(reportlist.map((item) => ({
                            reportHeaderId: item.reportHeaderId,
                            clientGroup: item.allocationClientGroup
                          })));
                        } else {
                          // Deselect all
                          setSelectedRow([]);
                        }
                      }}
                    />

                  </TableCell>
                  <TableCell sx={{ color: "white" }}>CheckIn Time</TableCell>
                  <TableCell sx={{ color: "white" }}>CheckOut Time</TableCell>
                  <TableCell sx={{ color: "white", minWidth: '120px' }}>Task Date</TableCell>
                  {/* <TableCell sx={{ color: "white" }}>Selected Time</TableCell> */}
                  <TableCell sx={{ color: "white" }}>Site</TableCell>
                  <TableCell sx={{ color: "white" }}>Site Code</TableCell>
                  <TableCell sx={{ color: "white" }}>Month</TableCell>
                  <TableCell sx={{ color: "white" }}>Entered by</TableCell>
                  <TableCell sx={{ color: "white" }}>Approved by</TableCell>
                  <TableCell sx={{ color: "white" }}>Editor Name</TableCell>
                  <TableCell sx={{ color: "white" }}>Score</TableCell>
                  <TableCell sx={{ color: "white" }}>PDF</TableCell>
                  {reportlist[0]?.isAllowDownloadWithoutComments === 1 && (<TableCell sx={{ color: "white" }}></TableCell>)}
                  <TableCell sx={{ color: "white" }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reportlist.length > 0 ? (

                  reportlist
                    ?.sort((a: any, b: any) => {
                      return new Date(b.inspectionDateTime).getTime() - new Date(a.inspectionDateTime).getTime();
                    })
                    .map((row, index) => {
                      const date = new Date(
                        row.selectedVisitDate
                      ).toLocaleDateString("en-GB");
                      // const time = new Date(
                      //   row.inspectionDateTime
                      // ).toLocaleTimeString("en-GB");
                      let timeDifference = "00:00:00";

                      if (row.reportStatusCode !== "unc" && row.submitDate && row.reportCreatedDate) {
                        const submitDate: any = new Date(row.submitDate);
                        const reportCreatedDate: any = new Date(row.reportCreatedDate);

                        const diffMs = Math.abs(submitDate - reportCreatedDate);

                        const hours = Math.floor(diffMs / (1000 * 60 * 60));
                        const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
                        const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

                        timeDifference = `${hours.toString().padStart(2, "0")}:${minutes
                          .toString()
                          .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
                      }

                      const fleetMatch = row.reportAddOnQuestions?.match(/Fleet Number:\s*(\d+)/);
                      return (
                        <TableRow key={index}>
                          <TableCell padding="checkbox">
                            <Checkbox
                              // checked={selectedRow.includes(row.reportHeaderId)}
                              // onChange={() => { handleSelectRow(row.reportHeaderId) }}
                              checked={selectedRow.some(item =>
                                item.reportHeaderId === row.reportHeaderId && item.clientGroup === row.allocationClientGroup
                              )}
                              onChange={() => {
                                handleSelectRow(row.reportHeaderId, row.allocationClientGroup);
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            {row?.checkInDateTime && (
                              <>
                                <Typography variant="body2">
                                  {new Date(row.checkInDateTime).toLocaleDateString('en-GB', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',
                                  })}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  {new Date(row.checkInDateTime).toLocaleTimeString()}
                                </Typography>
                              </>
                            )}
                          </TableCell>
                          <TableCell>
                            {row?.checkOutDateTime && (
                              <>
                                <Typography variant="body2">
                                  {new Date(row.checkOutDateTime).toLocaleDateString('en-GB', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',
                                  })}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  {new Date(row.checkOutDateTime).toLocaleTimeString()} ({formatDuration(row.checkInDateTime, row.checkOutDateTime)})
                                </Typography>
                              </>
                            )}
                          </TableCell>
                          <TableCell>
                            {date}<br />
                            <Tooltip title={row.visitTimeInformation || ""} arrow>
                              <Typography
                                variant="caption"
                                className="text-center"
                                color="text.secondary"
                                sx={{ cursor: "pointer" }}
                              >
                                {row.visitTimeInformation && row.visitTimeInformation.length > 10
                                  ? row.visitTimeInformation.substring(0, 10) + "..."
                                  : row.visitTimeInformation}
                              </Typography>
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            <Link
                              to={localStorage.getItem('userRoleName') === "Editor" ? `/editor/venue-reports/${row.venueId}` : `/admin/venue-reports/${row.venueId}`}
                              style={{ cursor: "pointer !important", textDecoration: "underline !important" }}
                            >
                              {row.venueName} {fleetMatch ? `(${fleetMatch[1]})` : ''}
                            </Link>
                          </TableCell>
                          <TableCell>{row.venueCode}</TableCell>
                          <TableCell>{row.reportMonth}</TableCell>
                          <TableCell
                            style={{ cursor: "pointer", textDecoration: "underline" }}
                            onClick={(e) => {
                              //setLoanData(item);
                              handleHover(e, index, row);
                            }}
                          >
                            {row.displayName}
                          </TableCell>
                          <TableCell>{row.approvedByFirstName} {row.approvedByLastName}</TableCell>
                          <TableCell>{row.editorName}</TableCell>
                          <TableCell sx={{ bgcolor: "#e8f5e9" }}>
                            {row.finalScore}
                          </TableCell>
                          <TableCell
                            onClick={() => handleDownloadPdf(row.allocationId, row.allocationClientGroup, false, row.venueName, row?.venueCode)}
                          >
                            <IconButton size="small">
                              <Description />
                            </IconButton>
                          </TableCell>
                          {row.isAllowDownloadWithoutComments === 1 && (<TableCell
                            onClick={() => handleDownloadPdf(row.allocationId, row.allocationClientGroup, true, row.venueName, row?.venueCode)}
                          >
                            <IconButton  >
                              <Typography className="text-dark" variant="h4">&reg;</Typography>
                            </IconButton>
                          </TableCell>)}
                          <TableCell>
                            <Box sx={{ display: "flex", gap: 0.5 }}>
                              <Tooltip title="Brief" arrow>
                                <span>
                                  <IconButton
                                    onClick={() => { setOpenEditDescription(true); if (row) { setRatingComment(row.venueDescription); seteditedvenueId(row.venueId); seteditedclientEntityId(clientEntityId) } }}
                                  >
                                    <NoteAdd sx={{ color: 'black' }} />
                                  </IconButton>
                                </span>
                              </Tooltip>
                              <Tooltip title="Copyright" arrow>
                                <span>
                                  <IconButton size="small" className="iconColor">
                                    <Copyright />
                                  </IconButton>
                                </span>
                              </Tooltip>
                              {row?.allocationClientGroup === "ALDI" && (<Tooltip title="Shopper Rating" arrow>
                                <span>
                                  <IconButton
                                    size="small"
                                    className="iconColor"
                                    onClick={() =>
                                      handleOpenRatingDialog(row.reportHeaderId, row.allocationClientGroup)
                                    }
                                  >
                                    <Star />
                                    <sub style={{ fontSize: "0.75rem" }}>
                                      ({Math.round(row.starRatingScore)})
                                    </sub>
                                  </IconButton>
                                </span>
                              </Tooltip>
                              )}
                              <Tooltip title="Editor Summary" arrow>
                                <span>
                                  <IconButton
                                    size="small"
                                    className="iconColor"
                                    onClick={() => {
                                      handleOpeneditorSummeryDialog(row.reportHeaderId, row.allocationClientGroup);
                                    }}
                                  >
                                    <Chat />
                                  </IconButton>
                                </span>
                              </Tooltip>
                              <Tooltip title="Bonus" arrow>
                                <span>
                                  <Badge
                                    color="error"
                                    variant="dot"
                                    invisible={row.bonus === "0.00" || row.bonus === null}
                                  >

                                    <IconButton
                                      size="small"
                                      className="iconColor"
                                      onClick={() => {
                                        handleOpenBonusDialog(row.reportHeaderId, row.allocationClientGroup);
                                      }}
                                    >
                                      <CardGiftcard />
                                    </IconButton>
                                  </Badge>
                                </span>
                              </Tooltip>
                              <Tooltip title="penalty" arrow>
                                <span>
                                  <IconButton

                                    size="small"
                                    className="iconColor"
                                    onClick={() => {
                                      handleOpenPenaltyDialog(row.reportHeaderId, row.allocationClientGroup);
                                    }}
                                  >
                                    <Warning
                                      sx={{
                                        color:
                                          row.penalty && row.penalty !== "0.00"
                                            ? "red"
                                            : "inherit",
                                      }}
                                    />
                                  </IconButton>
                                </span>
                              </Tooltip>

                              <Tooltip title="Rollback" arrow>
                                <IconButton
                                  // disabled={displayStatus == 4 }
                                  // disabled={displayStatus == 4 && row.canClientEditReports === 1}
                                  size="small"
                                  className="iconColor"
                                  sx={{ transform: "scaleX(-1)" }}
                                  onClick={() => {
                                    // handleRollBack(row.reportHeaderId, "unc", row.allocationClientGroup);
                                    setOpenHoldReason(true);
                                    setHeaderId(row.reportHeaderId);
                                    setGroup(row.allocationClientGroup);
                                  }}
                                >
                                  <Refresh />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Approve" arrow>
                                <IconButton
                                  size="small"
                                  className="iconColor"
                                  onClick={() => {
                                    handleApproved(row.reportHeaderId, "app", row.canClientEditReports, row?.allocationClientGroup);
                                  }}
                                >
                                  <CheckCircle sx={{ color: 'green !important' }} />
                                </IconButton>
                              </Tooltip>
                              {row?.allocationClientGroup !== "ALDI" && (<Tooltip title="Shopper Rating" arrow>
                                <span>
                                  <IconButton
                                    size="small"
                                    className="iconColor"
                                    onClick={() =>
                                      handleOpenRatingDialog(row.reportHeaderId, row.allocationClientGroup)
                                    }
                                  >
                                    <Star />
                                    <sub style={{ fontSize: "0.75rem" }}>
                                      ({Math.round(row.starRatingScore)})
                                    </sub>
                                  </IconButton>
                                </span>
                              </Tooltip>
                              )}
                              <Tooltip title="Release" arrow>
                                <IconButton
                                  // disabled={row.canClientEditReports === 1}
                                  size="small"
                                  className="iconColor"
                                  onClick={() => {
                                    handleReleased(row.reportHeaderId, "rel", row.canClientEditReports, row.allocationClientGroup);
                                  }}
                                >
                                  <Send sx={{ color: 'red !important' }} />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Alert Shopper" arrow>
                                <IconButton size="small" className="iconColor">
                                  <Info />
                                </IconButton>
                              </Tooltip>

                              <Tooltip title="Edit Report" arrow>
                                <IconButton
                                  size="small"
                                  className="iconColor"
                                  onClick={() => {
                                    OpenEditReport(row)
                                  }}
                                >
                                  <Edit />
                                </IconButton>
                              </Tooltip>
                              {displayStatus == 4 && (
                                <Tooltip title={row?.isReleaseMailSend ? "Email Sent" : "Email Not Sent"} arrow>
                                  <Box height={'10px'} className='m-auto mx-0' width={'10px'} borderRadius={'50px'} bgcolor={row?.isReleaseMailSend ? "green" : "red"}></Box>
                                </Tooltip>)}
                              {(displayStatus == 3 || displayStatus == 5) && (
                                <Tooltip title={row?.isApprovedMailSend ? "Email Sent" : "Email Not Sent"} arrow>
                                  <Box height={'10px'} className='m-auto mx-0' width={'10px'} borderRadius={'50px'} bgcolor={row?.isApprovedMailSend ? "green" : "red"}></Box>
                                </Tooltip>)}
                            </Box>
                          </TableCell>
                        </TableRow>
                      );
                    })
                ) : (
                  <TableRow>
                    <TableCell colSpan={9}>
                      <Typography className="text-center fw-bold" variant="h5">
                        Data Not Found
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Box>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={datalength}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>

        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          {loanData ? (<Dcrage handleClose={handleClose} loanData={loanData} />) : null}
        </Popover>

        {/* Bonus Dialog */}
        <Dialog
          open={bonusDialogOpen}
          onClose={handleCloseBonusDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pb: 1,
            }}
          >
            <Typography variant="h6">Bonus</Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleCloseBonusDialog}
              aria-label="close"
            >
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Box sx={{ mb: 3 }}>
              <Typography variant="body1" sx={{ mb: 1, fontWeight: "medium" }}>
                Amount:
              </Typography>
              <TextField
                fullWidth
                value={bonusAmount}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const value: any = e.target.value;
                  if (parseFloat(value) >= 0 || value === "") {
                    setBonusAmount(value);
                  }
                }}
                variant="outlined"
                type="number"
                inputProps={{ min: 0, step: 0.01 }}
              />
            </Box>
            <Box>
              <Typography variant="body1" sx={{ mb: 1, fontWeight: "medium" }}>
                Reason:
              </Typography>
              <TextField
                fullWidth
                value={bonusReason}
                onChange={(e: any) => setBonusReason(e.target.value)}
                variant="outlined"
                multiline
                rows={4}
              />
            </Box>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center", py: 2 }}>
            <OliveButton onClick={handleSaveBonus}>Save</OliveButton>
          </DialogActions>
        </Dialog>

        {/* Panelty Dialog */}
        <Dialog
          open={penaltyDialogOpen}
          onClose={handleClosePenaltyDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pb: 1,
            }}
          >
            <Typography variant="h6">Penalty</Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleClosePenaltyDialog}
              aria-label="close"
            >
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Box sx={{ mb: 3 }}>
              <Typography variant="body1" sx={{ mb: 1, fontWeight: "medium" }}>
                Amount:
              </Typography>
              <TextField
                fullWidth
                value={penaltyAmount}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const value: any = e.target.value;
                  if (parseFloat(value) >= 0 || value === "") {
                    setPenaltyAmount(value);
                  }
                }}
                variant="outlined"
                type="number"
                inputProps={{ min: 0, step: 0.01 }}
              />
            </Box>
            <Box>
              <Typography variant="body1" sx={{ mb: 1, fontWeight: "medium" }}>
                Reason:
              </Typography>
              <TextField
                fullWidth
                value={penaltyReason}
                onChange={(e: any) => setPenaltyReason(e.target.value)}
                variant="outlined"
                multiline
                rows={4}
              />
            </Box>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center", py: 2 }}>
            <OliveButton onClick={handleSavePenalty}>Save</OliveButton>
          </DialogActions>
        </Dialog>

        {/* Editor Summery Dialog */}
        <Dialog
          open={editorSummeryDialogOpen}
          onClose={handleCloseEditorSummeryDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pb: 1,
            }}
          >
            <Typography variant="h6">Editor Summary:</Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleCloseEditorSummeryDialog}
              aria-label="close"
            >
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Box>
              <TextField
                fullWidth
                value={editorSummery}
                onChange={(e: any) => setEditorSummery(e.target.value)}
                variant="outlined"
                multiline
                rows={4}
              />
            </Box>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center", py: 2 }}>
            <OliveButton onClick={handleSaveEditorSummery}>Save</OliveButton>
          </DialogActions>
        </Dialog>

        {/* Shopper Rating Dialog */}
        <Dialog
          open={ratingDialogOpen}
          onClose={handleCloseRatingDialog}
          maxWidth="md"
          fullWidth
          className="shopperRating"
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pb: 1,
            }}
          >
            <Typography variant="h6">Shopper Rating</Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleCloseRatingDialog}
              aria-label="close"
            >
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Box sx={{ mb: 3 }}>
              {/* Top row ratings */}
              <Grid container spacing={3}>
                {/* Overall Report */}
                {masterRating.length > 0 &&
                  masterRating.map((items, index) => {
                    const currentRating =
                      ratings &&
                      ratings.find(
                        (rating) => rating.overRatingId === items.overAllRatingId
                      );
                    return (
                      <>
                        {index == 3 && (
                          <Divider
                            className="col-10 mx-auto"
                            sx={{ my: 3, borderColor: "grey" }}
                          />
                        )}
                        <Grid item xs={4} sx={{ width: "31.33%" }}>
                          <Box sx={{ textAlign: "center" }}>
                            <Typography variant="body1" sx={{ mb: 1 }}>
                              {items.overAllRatingId} {items.overAllRatingDesc}
                            </Typography>
                            <RatingEmoji
                              rating={currentRating?.overAllRatingScore}
                            />
                            <Box
                              sx={{ display: "flex", justifyContent: "center" }}
                            >
                              <Rating
                                name="overall-report"
                                value={currentRating?.overAllRatingScore}
                                onChange={(_, newValue) => {
                                  if (newValue !== null) {
                                    handleRatingChange(
                                      items.overAllRatingId,
                                      newValue
                                    );
                                  }
                                }}
                              />
                            </Box>
                          </Box>
                        </Grid>
                      </>
                    );
                  })}
              </Grid>

              <Divider sx={{ my: 3 }} />

              {/* Comments Section */}
              <Box sx={{ mt: 4 }}>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: "medium" }}>
                  Comments:
                </Typography>

                {/* Rich Text Editor */}
                <Editor
                  setValue={setRatingComment}
                  value={ratingComment}
                  isUpdate={false}
                />
              </Box>
            </Box>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center", py: 2 }}>
            <OliveButton onClick={handleSaveRating}>
              Save & Inform shopper
            </OliveButton>
          </DialogActions>
        </Dialog>
        {/* Shopper Hold Reason Dialog */}
        <Dialog open={OpenHoldReason} onClose={() => { setOpenHoldReason(false) }}>
          <DialogContent>
            <TextField
              required

              className='p-0'
              sx={{
                width: '300px',
                ".MuiOutlinedInput-input ": {
                  padding: '10px'
                },
                ".MuiInputLabel-root": {
                  top: '-6px'
                }
              }}
              value={reasonforhold}
              onChange={(e) => { setreasonforhold(e.target.value) }}
              id="outlined-required"
              label="Reason"
            />
            <Button sx={{ color: 'white' }} className="d-block mt-3 mx-auto action-button action-button--approve table-row-background"
              onClick={() => { (reasonforhold?.length > 0) ? handleRollBack("unc") : alert("Reason is requierd") }}>
              Submit
            </Button>
          </DialogContent>
        </Dialog>

        {/* Site Bried Json Dialog */}
        <Dialog open={OpenEditDescription}
          PaperProps={{
            sx: {
              width: '900px',
              height: 'fit-content',
              maxWidth: 'none'
            }
          }}
        >
          <DialogContent className="p-3 d-flex flex-column gap-5">
            <Box className='d-flex align-items-center justify-content-between'>
              <Typography className="fw-bold" variant="h5">Update Job Description</Typography>
              <IconButton onClick={() => { setOpenEditDescription(false); setSelectedVenue([]); }}>
                <CancelOutlined />
              </IconButton>
            </Box>
            <Box className='mt-3'>
              {/* <PatchedReactQuill
              setEditorValue={setEditorValue}
              editorValue={editorValue}
              isUpdate={false}
            /> */}
              <Editor
                setValue={setRatingComment}
                value={ratingComment}
                isUpdate={false}
              />
            </Box>
            {/* <FormControlLabel className="my-1 mt-2" control={<Checkbox checked={isResetQuiz} onChange={() => { setisResetQuiz(!isResetQuiz) }} />} label="Reset quiz for this business" /> */}
            <FormControl sx={{ marginTop: 2, mb: 2 }}>
              <Autocomplete
                multiple
                id="venue-autocomplete"
                options={[{ venueId: "all", venueName: "Select All" }, ...briefVenue]}
                disableCloseOnSelect
                value={briefVenue?.filter((option: any) =>
                  selectedVenue?.includes(option.venueId)
                )}
                getOptionLabel={(option: any) => option.venueName}
                onChange={(event, newValue: any[]) => {
                  const isSelectAll = newValue.some((v: any) => v.venueId === "all");

                  if (isSelectAll) {
                    if (selectedVenue.length === briefVenue.length) {
                      setSelectedVenue([]);
                    } else {
                      setSelectedVenue(briefVenue.map((v: any) => v.venueId));
                    }
                  } else {
                    const venueIds = newValue.map((v: any) => v.venueId);
                    setSelectedVenue(venueIds);
                  }
                }}
                renderOption={(props, option: any) => {
                  const isAll = option.venueId === "all";
                  const checked = isAll
                    ? selectedVenue.length === briefVenue.length
                    : selectedVenue.includes(option.venueId);

                  return (
                    <li {...props}>
                      <Checkbox
                        checked={checked}
                        style={{ marginRight: 8 }}
                      />
                      {option.venueName}
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Select Sites" />
                )}
                size="small"
              />
            </FormControl>
            <Button variant="contained" onClick={quizretake}
              className="table-row-background my-1 mx-auto" sx={{ width: 'fit-content', textTransform: 'none' }}>Submit</Button>
          </DialogContent>
        </Dialog>
      </Box>
    </Box >
  );
}
